import { z } from 'zod';
export var CaptchaType;
(function (CaptchaType) {
    CaptchaType["RecaptchaEnterprise"] = "RecaptchaEnterprise";
    CaptchaType["Turnstile"] = "Turnstile";
})(CaptchaType || (CaptchaType = {}));
export var RecaptchaEnterpriseMode;
(function (RecaptchaEnterpriseMode) {
    RecaptchaEnterpriseMode["Invisible"] = "invisible";
    RecaptchaEnterpriseMode["Checkbox"] = "checkbox";
})(RecaptchaEnterpriseMode || (RecaptchaEnterpriseMode = {}));
export const turnstileConfigGuard = z.object({
    type: z.literal(CaptchaType.Turnstile),
    siteKey: z.string(),
    secretKey: z.string(),
});
export const recaptchaEnterpriseConfigGuard = z.object({
    type: z.literal(CaptchaType.RecaptchaEnterprise),
    siteKey: z.string(),
    secretKey: z.string(),
    projectId: z.string(),
    domain: z.string().optional(),
    mode: z.nativeEnum(RecaptchaEnterpriseMode).optional(),
});
export const captchaConfigGuard = z.discriminatedUnion('type', [
    turnstileConfigGuard,
    recaptchaEnterpriseConfigGuard,
]);
